import citywideModel from 'data/municipal_plan_sidebar.json';
import UBLegend from 'data/urbanstructure-legend.json';
import blankLegend from 'data/blank-legend.json';
import { getHandlerFor } from 'client/utils/angular';

export default function ($scope, Maps, $window,$rootScope, sidebarService) {
  $scope.citywideSidebar = Object.assign({}, citywideModel);
  $scope.urbanstructureOn = false;
  $scope.rightofwayOn = false;

  const update = ({ urbanstructure, rightofway }) => {
    $scope.citywideSidebar.urbanstructure = {}; //Clear Urban Structure Layer Information
    $scope.citywideSidebar.rightofway = {}; //Clear right of way layer information

    //Check for Urban Structure info
    if ('no_result' in urbanstructure) {
      $scope.urbanstructureOn = false;
      $scope.citywideSidebar.urbanstructure.error = urbanstructure.no_result;

      if ($scope.myp_municipality != 'Toronto') {
        $scope.citywideSidebar.urbanstructure.error = "Our Platform currently does not provide information in this area.";
      };

    } else if ('error' in urbanstructure) {
      $scope.urbanstructureOn = false;
      $scope.citywideSidebar.urbanstructure.error = urbanstructure.error;
    } else {
      // set urban structure info
      $scope.citywideSidebar.urbanstructure = urbanstructure;
      $scope.urbanstructureOn = true;
    }

    // Set ROW
    if ('no_result' in rightofway) {
      $scope.rightofwayOn = false;
      $scope.citywideSidebar.rightofway.error = rightofway.no_result;
    } else if ('error' in rightofway) {
      $scope.rightofwayOn = false;
      $scope.citywideSidebar.rightofway.error = rightofway.error;
    } else {
      // set right of way info
      $scope.citywideSidebar.rightofway = rightofway;
      $scope.rightofwayOn = true;
    }
  };

  if($scope.myp_municipality == 'Toronto') {
    if($scope.legendTitle != "cw")
      $rootScope.$broadcast('map/setlegend', [UBLegend,"cw"]);
  } else {
    if($scope.legendTitle != "blank")
      $rootScope.$broadcast('map/setlegend', [blankLegend, "blank"]);
  }

  if(!$scope.isSearchBar) {
    //reset official on/off button if needed.
    $scope.citywideSidebar.urban[0].toggle = $scope.checkLayer($scope.citywideSidebar.urban[0].name);
    //reset secondary on/off button if needed.
    $scope.citywideSidebar.rowwidth[0].toggle = $scope.checkLayer($scope.citywideSidebar.rowwidth[0].name);


    if(!$scope.onSidebar) {
      sidebarService.sidebarInfo({
        type: "opcitywide-toronto_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
    }
  }

  $scope.policyLink = function (url) {
    $window.open(url,'_blank');
  };

  if($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  const toggle = (status) => {
    $scope.citywideSidebar.urban[0].toggle = status;
    $scope.citywideSidebar.rowwidth[0].toggle = status;
  };

  const reset = () => {
    $scope.citywideSidebar = Object.assign({}, citywideModel);

    $scope.urbanstructureOn = false;
    $scope.rightofwayOn = false;
  };

  $rootScope.$on('sidebar/citywide/update', getHandlerFor(update));
  $rootScope.$on('sidebar/citywide/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/citywide/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/municipal_plan_sidebar.js